import React from 'react';
import CheckBox from '../../../../components/check-box';
import { ApiPermissions } from '../../../../core';

interface PermissionCheckboxProps {
  onSelection?: (permission: string, selected: boolean) => void;
  permission: ApiPermissions;
  disabled?: boolean;
}

const PermissionCheckbox: React.SFC<PermissionCheckboxProps> = (props) => {
  const { onSelection, permission } = props;
  if (!permission) {
    return <></>;
  }
  return (
    <div className="timeline-checkbox">
      <CheckBox
        id={permission.permission}
        checked={permission.selected}
        label={permission.name}
        labelClassName="font-normal font-weight-semibold text-gray-800"
        onChange={(val) => {
          if (onSelection) {
            onSelection(permission.permission, val);
          }
        }}
        disabled={props.disabled}
      />
    </div>
  );
};

export default PermissionCheckbox;
